import { jsx as _jsx } from "react/jsx-runtime";
import styles from './TextLink.module.css';
export function TextLink({ linkAs, className, ...rest }) {
    const Anchor = linkAs ?? 'a';
    const composed = className
        ? `${styles.textLink} ${className}`
        : styles.textLink;
    return _jsx(Anchor, { className: composed, ...rest });
}
//# sourceMappingURL=TextLink.js.map